// assets/testimonial-dialog.js
// Opens carousel cards with long text in a dialog (live site only, disabled in theme editor)

(() => {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  const MIN_TEXT_LENGTH = 140;

  function ensureDialog() {
    let host = document.querySelector('dialog-component.testimonial-dialog-host');
    if (host) return host;

    host = document.createElement('dialog-component');
    host.className = 'testimonial-dialog-host';

    host.innerHTML = `
      <dialog ref="dialog" class="testimonial-dialog" aria-label="Testimonial">
        <button type="button" class="testimonial-dialog__close" aria-label="Close dialog" data-testimonial-close>
          ×
        </button>
        <div class="testimonial-dialog__body" data-testimonial-body></div>
      </dialog>
    `;

    document.body.appendChild(host);

    host.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-testimonial-close]');
      if (closeBtn) host.closeDialog();

      // close when clicking backdrop (outside dialog)
      const dialogEl = host.querySelector('dialog[ref="dialog"]');
      if (e.target === dialogEl) host.closeDialog();
    });

    return host;
  }

  function isExpandableCard(cardEl) {
    if (!cardEl) return false;

    // We target carousel cards that are aspect-ratio constrained (typical for your testimonials)
    const constrained = cardEl.querySelector('.card__content--has-min-height');
    if (!constrained) return false;

    const textEl = cardEl.querySelector('.text-block, rte-formatter, .rte');
    if (!textEl) return false;

    const txt = (textEl.textContent || '').trim();
    return txt.length >= MIN_TEXT_LENGTH;
  }

  function buildModalCard(cardEl) {
    const clone = cardEl.cloneNode(true);

    // Remove overlay link so it won't block scrolling/selection inside dialog
    const link = clone.querySelector('.card__link');
    if (link) link.remove();

    // Remove carousel-only refs/attrs that are irrelevant inside the dialog
    clone.removeAttribute('ref');
    clone.querySelectorAll('[ref]').forEach((n) => n.removeAttribute('ref'));

    // Make it focus-friendly
    clone.setAttribute('tabindex', '-1');
    clone.classList.add('testimonial-dialog__card');

    return clone;
  }

  function openCard(cardEl) {
    const host = ensureDialog();
    const body = host.querySelector('[data-testimonial-body]');
    if (!body) return;

    body.innerHTML = '';
    body.appendChild(buildModalCard(cardEl));

    host.showDialog();
  }

  document.addEventListener('click', (e) => {
    // ignore clicks on controls/links/buttons
    if (e.target.closest('a, button, input, textarea, select, label')) return;

    const card = e.target.closest('.section-carousel .card[data-carousel-card]');
    if (!card) return;

    if (!isExpandableCard(card)) return;

    e.preventDefault();
    openCard(card);
  });
})();
